"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToDepartmentModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var org_department_selector_1 = require("../org.department.selector/org.department.selector");
var collection_move_modal_ctrl_1 = require("./collection.move.modal.ctrl");
var collection_move_modal_style_1 = require("./collection.move.modal.style");
(0, theme_1.addStyles)(collection_move_modal_style_1.Style);
var CollectionMoveToDepartmentModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionMoveToDepartmentModal, _super);
    function CollectionMoveToDepartmentModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.ctrl = new collection_move_modal_ctrl_1.CollectionMoveModalCtrl(collections);
        _this.departmentSelector = new org_department_selector_1.OrgDepartmentSelector({ crossOrganization: true });
        _this.addState(_this.departmentSelector.inputState);
        return _this;
    }
    Object.defineProperty(CollectionMoveToDepartmentModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_CONFIRM, { count: this.ctrl.collections.length })),
                    this.departmentSelector.view()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionMoveToDepartmentModal.prototype.submit = function () {
        return this.ctrl.moveCollections(this.departmentSelector.selectedDepartmentId);
    };
    return CollectionMoveToDepartmentModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionMoveToDepartmentModal = CollectionMoveToDepartmentModal;
//# sourceMappingURL=collection.move.modal.js.map